import currentlyShownActions from '../../actions/CurrentlyShownActions';

const { types } = currentlyShownActions;

const createProdLogger = () => next => (action) => {
    const actionType = action.type;
    if (actionType === types.UPDATE_CURRENTLY_SHOWN) {
        window.console.log(action);
    } else {
        window.console.log('action:', actionType);
    }

    return next(action);
};

export default createProdLogger;
